<template>
    <div class="pagePolicy">
        <div class="pageInfos">
            <div class="policyTitle">{{$t('policies.cookies.title')}}</div>
            <div class="policyLastUpdated">
                <font-awesome-icon :icon="icons.calendar" class="fa-fw fa-lg"></font-awesome-icon>
                {{$t('policies.lastUpdate')}} {{$t('policies.cookies.update')}}
            </div>
            <div class="policyDescription" v-html="$t('policies.cookies.message')"></div>
        </div>
    </div>
</template>

<script>
import PoliciesMixin from "./PoliciesMixin";
export default {
    mixins: [PoliciesMixin]
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/policies.scss";
</style>
